import firebase from 'firebase/app'
import 'firebase/firestore'

export const db = firebase
    .initializeApp({projectId: 'panoptes-exp'})
    .firestore()

// if (location.hostname === "localhost") {
//     db.useEmulator("localhost", 8080);
// }


// Export types that exists in Firestore - Uncomment if you need them in your app
const {Timestamp, GeoPoint} = firebase.firestore
export {Timestamp, GeoPoint}
